<template lang="pug">
#users
  main.relative.text-gray-700
    section.relative.shadow-md.rounded.overflow-hidden
      .absolute.inset-0.bg-white.opacity-75

      .relative
        h2.text-xl.uppercase.tracking-wider.p-4 Create User

        form.p-4(@submit.prevent="submit")
          .mb-4.rounded.shadow
            .relative.h-12.overflow-hidden
              .absolute.inset-0.pl-24
                input.h-12.w-full.px-4(placeholder="Username" name="username" v-model="username")
              label.text-xs.uppercase.tracking-wider.absolute.inset-0.w-24.flex.items-center.justify-center.bg-gray-200 Username

            .relative.h-12.overflow-hidden.border-t.border-gray-300
              .absolute.inset-0.pl-24
                input.h-12.w-full.px-4(placeholder="Password" type="password" name="password" v-model="password")
              label.text-xs.uppercase.tracking-wider.absolute.inset-0.w-24.flex.items-center.justify-center.bg-gray-200 Password

            .relative.h-12.overflow-hidden.border-t.border-gray-300
              .absolute.inset-0.pl-24
                input.h-12.w-full.px-4(placeholder="Company" type="text" name="company" v-model="company")
              label.text-xs.uppercase.tracking-wider.absolute.inset-0.w-24.flex.items-center.justify-center.bg-gray-200 Company

            .relative.h-12.overflow-hidden.border-t.border-gray-300
              .absolute.inset-0.pl-24
                input.h-12.w-full.px-4(placeholder="Remark" type="text" name="remark" v-model="remark")
              label.text-xs.uppercase.tracking-wider.absolute.inset-0.w-24.flex.items-center.justify-center.bg-gray-200 Remark

            .relative.h-12.overflow-hidden.border-t.border-gray-300
              .absolute.inset-0.pl-24
                .h-12.w-full.px-4.flex.items-center.bg-white
                  label.mx-2.flex.items-center
                    input(type="checkbox" value="lesson-2" v-model="lessons")
                    span.ml-1 Lesson 2
                  label.mx-2.flex.items-center
                    input(type="checkbox" value="lesson-3" v-model="lessons")
                    span.ml-1 Lesson 3
              label.text-xs.uppercase.tracking-wider.absolute.inset-0.w-24.flex.items-center.justify-center.bg-gray-200 Lessons

            .relative.h-12.overflow-hidden.border-t.border-gray-300
              .absolute.inset-0.pl-24
                flat-pickr.h-12.w-full.px-4(v-model="start")
              label.text-xs.uppercase.tracking-wider.absolute.inset-0.w-24.flex.items-center.justify-center.bg-gray-200 Start

            .relative.h-12.overflow-hidden.border-t.border-gray-300
              .absolute.inset-0.pl-24
                flat-pickr.h-12.w-full.px-4(v-model="end")
              label.text-xs.uppercase.tracking-wider.absolute.inset-0.w-24.flex.items-center.justify-center.bg-gray-200 End

          .mb-4.text-red-500.text-sm(v-if="error") {{ error }}

          button.rounded.shadow.w-full.h-12.bg-teal-500.text-white(class="hover:bg-teal-600" :disabled="isSubmitting") Create

    section.relative.mt-4.shadow-md.rounded.overflow-hidden
      .absolute.inset-0.bg-white.opacity-75

      .relative
        .p-4(class="md:flex")
          .flex.flex-grow.items-center(class="md:pr-4")
            h2.text-xl.uppercase.tracking-wider.flex-grow Users
            a.text-xs.underline.text-blue-500(href="/api/user/export/csv") Export CSV
          .w-full.relative.mt-2(class="md:mt-0 md:w-64")
            input.w-full.h-10.pl-10.bg-white.rounded.shadow(v-model.trim="search")
            .h-10.w-10.absolute.top-0.left-0.flex.items-center.justify-center
              i.fa.fa-search

        .overflow-auto.w-full
          table.w-full.bg-white
            thead
              tr.uppercase.tracking-wider.text-xs.bg-gray-300
                th.font-light.p-2.border-gray-500.border-r.w-40 Username
                th.font-light.p-2.border-gray-500.border-r.w-40 Password
                th.font-light.p-2.border-gray-500.border-r Created
                th.font-light.p-2.border-gray-500.border-r Period
                th.font-light.p-2.border-gray-500.border-r Company
                th.font-light.p-2.border-gray-500.border-r Remark
                th.font-light.p-2.border-gray-500.border-r Lessons
                th.font-light.p-2.border-gray-500.border-r Logins
                th.font-light.p-1.w-20

            tbody
              tr.border-gray-500.border-t(class="hover:bg-gray-200" v-for="user in filteredUsers" :key="user.username")
                td.p-2.border-gray-500.border-r {{ user.username }}
                td.p-2.border-gray-500.border-r.text-center
                  button.text-blue-500.w-8.h-8.rounded(class="hover:bg-blue-500 hover:text-white" @click="reveal(user)" v-if="!user.decryptedPassword")
                    i.fa.fa-eye
                  span(v-if="user.decryptedPassword") {{ user.decryptedPassword }}
                  button.text-blue-500.w-8.h-8.rounded.ml-4(class="hover:bg-blue-500 hover:text-white" @click="hide(user)" v-if="user.decryptedPassword")
                    i.fa.fa-eye-slash
                td.p-2.border-gray-500.border-r.text-center {{ user.created }}
                td.p-2.border-gray-500.border-r.text-center {{ user.start }} - {{ user.end }}
                td.p-2.border-gray-500.border-r.text-center {{ user.company || '' }}
                td.p-2.border-gray-500.border-r.text-center {{ user.remark || '' }}
                td.p-2.border-gray-500.border-r.text-center {{ user.lessons ? user.lessons.join(' ') : '' }}
                td.p-2.border-gray-500.border-r.text-center(v-html="(user.logins || []).join('<br />')")
                td.w-20.p-1.text-center
                  button.text-red-500.w-8.h-8.rounded(class="hover:bg-orange-500 hover:text-white" v-if="isLoggedIn(user)" @click="logout(user)")
                    i.fa.fa-sign-out-alt
                  router-link.text-teal-500.w-8.h-8.rounded(tag="button" :to="'/dashboard/user/' + user.username" class="hover:bg-teal-500 hover:text-white")
                    i.fa.fa-pencil-alt
                  button.text-red-500.w-8.h-8.rounded(class="hover:bg-red-500 hover:text-white" @click="remove(user)")
                    i.fa.fa-times
</template>

<script>
import axios from 'axios'
import dayjs from 'dayjs'
import { createComponent, ref, computed } from '@vue/composition-api'
import flatPickr from 'vue-flatpickr-component'

export default createComponent({
  components: {
    flatPickr
  },
  setup (props, context) {
    const users = ref([])

    axios.get('/api/user/list')
      .then(({ data: response }) => {
        users.value = response.map(user => {
          user.created = dayjs(user.created).format('YYYY-MM-DD HH:mm')

          return user
        })
      })

    const search = ref('')

    const filteredUsers = computed(() => {
      if (search.value === '') {
        return users.value
      }

      const pattern = new RegExp(search.value, 'i')

      return users.value.filter(user => {
        return pattern.test(user.username) || pattern.test(user.company) || pattern.test(user.remark)
      })
    })

    const isRemoving = ref(false)

    async function remove (user) {
      if (isRemoving.value) {
        return
      }

      try {
        await context.root.$confirm(`Delete user: ${user.username}`)
      } catch {
        return
      }

      isRemoving.value = true

      window.$LOADER.show('Deleting...')

      await axios.delete(`/api/user/${user.username}`)

      isRemoving.value = false

      const itemIndex = users.value.findIndex(item => item.username === user.username)

      if (itemIndex >= 0) {
        users.value.splice(itemIndex, 1)
      }

      window.$LOADER.hide()
    }

    async function reveal (user) {
      let master = ''

      try {
        master = await context.root.$prompt('Enter master password.', '', '', '', {
          input: 'password'
        })
      } catch {
        return
      }

      if (!master) {
        return
      }

      try {
        const { data: response } = await axios.post('/api/user/reveal/' + user.username, {
          master
        })

        user.decryptedPassword = response.decrypted

        users.value.splice(users.value.findIndex(item => item === user), 1, user)
      } catch {
        context.root.$alert('Invalid master password.', '', 'warning')
      }
    }

    function hide (user) {
      user.decryptedPassword = null

      users.value.splice(users.value.findIndex(item => item === user), 1, user)
    }

    function isLoggedIn (user) {
      const now = dayjs()

      return Boolean(
        user.loggedin &&
        user.lastlogin &&
        now.isBefore(dayjs(user.lastlogin).add(2, 'hour'))
      )
    }

    async function logout (user) {
      try {
        await context.root.$confirm(`Logout user: ${user.username}`)
      } catch {
        return
      }

      window.$LOADER.show('Logging out...')

      await axios.get(`/api/user/logout/${user.username}`)

      user.loggedin = 0

      const itemIndex = users.value.findIndex(item => item.username === user.username)

      if (itemIndex >= 0) {
        users.value.splice(itemIndex, 1, user)
      }

      window.$LOADER.hide()
    }

    const isSubmitting = ref(false)
    const username = ref('')
    const password = ref('')
    const error = ref('')

    async function submit () {
      if (!username.value || !password.value) {
        return
      }

      if (isSubmitting.value) {
        return
      }

      error.value = ''
      isSubmitting.value = true

      window.$LOADER.show('Saving...')

      try {
        const { data: user } = await axios.post('/api/user/create', {
          username: username.value,
          password: password.value,
          lessons: lessons.value,
          start: start.value,
          end: end.value,
          company: company.value,
          remark: remark.value
        })

        user.created = dayjs(user.created).format('YYYY-MM-DD HH:mm')

        username.value = ''
        password.value = ''
        company.value = ''
        remark.value = ''
        isSubmitting.value = false

        users.value.unshift(user)

        window.$LOADER.hide()
      } catch (err) {
        isSubmitting.value = false

        error.value = error.value = err.response && err.response.data && err.response.data.message ? err.response.data.message : 'Invalid credentials.'

        window.$LOADER.hide()
      }
    }

    const start = ref(dayjs().format('YYYY-MM-DD'))
    const end = ref(dayjs().add(3, 'month').format('YYYY-MM-DD'))
    const company = ref('')
    const remark = ref('')
    const lessons = ref([])

    return {
      users,
      search,
      filteredUsers,
      reveal,
      hide,
      remove,
      logout,
      isLoggedIn,
      username,
      password,
      isSubmitting,
      error,
      submit,
      lessons,
      start,
      end,
      company,
      remark
    }
  }
})
</script>
